/**
 * Household API client.
 * Handles household operations including invite link generation and acceptance.
 */

import { apiFetch } from './client';
import type {
  HouseholdResponse,
  InviteResponse,
  HouseholdInvite,
  AcceptInviteRequest,
  CreateHouseholdRequest,
} from '@shared/types';

/**
 * Get the current user's household.
 */
export async function getMyHousehold(): Promise<HouseholdResponse> {
  return apiFetch<HouseholdResponse>('/households/me');
}

/**
 * Create a new household.
 */
export async function createHousehold(data: CreateHouseholdRequest): Promise<HouseholdResponse> {
  return apiFetch<HouseholdResponse>('/households', {
    method: 'POST',
    body: JSON.stringify(data),
  });
}

/**
 * Generate a new invite link for the household.
 */
export async function createInvite(): Promise<InviteResponse> {
  return apiFetch<InviteResponse>('/households/invites', {
    method: 'POST',
  });
}

/**
 * Get all active invites for the household.
 */
export async function getInvites(): Promise<HouseholdInvite[]> {
  return apiFetch<HouseholdInvite[]>('/households/invites');
}

/**
 * Accept an invite and join a household.
 */
export async function acceptInvite(code: string): Promise<HouseholdResponse> {
  const data: AcceptInviteRequest = { code };
  return apiFetch<HouseholdResponse>('/households/invites/accept', {
    method: 'POST',
    body: JSON.stringify(data),
  });
}
